<template>
  <div>
    <div class="bg-color-red userform_top"></div>
    <div class="userform">
      <h3 class="userform_title">{{formTitle}}申请信息</h3>
      <div class="userform_item userform_item_red">
        <input type="text" placeholder="姓名" v-model.trim="formList.name"/>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 1">{{formlabel.text}}不能为空</p>
      </div>
      <div class="userform_item userform_item_red">
        <input type="number" placeholder="手机号码" v-model.trim="formList.phone"/>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 2">{{formlabel.text}}不能为空</p>
      </div>
      <div class="userform_item userform_item_red">
        <input type="number" placeholder="验证码" max="999999" v-model.trim="formList.verifi" class="yzm_number"/>
        <div class="yzm" :class="{'actived' : yzm.yzmstatus }" @click="yzmClick()">{{yzm.text}}</div>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 3">{{formlabel.text}}不能为空</p>
      </div>
      <div class="userform_item">
        <div class="item acea-row row-between-wrapper">
          <div class="name">选择城市：</div>
          <div
              class="picker acea-row row-between-wrapper select-value form-control"
          >
            <div class="address">
              <div slot="right" @click.stop="show2 = true">
                {{ model2 || "请选择所在地区" }}
              </div>
              <CitySelect
                  ref="cityselect"
                  v-model="show2"
                  :callback="result2"
                  :items="district"
                  :ready="ready"
                  provance=""
                  city=""
                  area=""
              ></CitySelect>
            </div>
            <div class="iconfont icon-dizhi font-color-red"></div>
          </div>
        </div>
      </div>
      <div class="userform_item">
        <div class="item acea-row row-between-wrapper">
        <div class="name">加盟标准：</div>
        <div
          class="picker acea-row row-between-wrapper select-value form-control"
        >
          <div class="address">
            <div slot="right"  @click="checkCondition">
              {{ joinStandard.describe || "请选择加盟标准" }}
            </div>
            <van-popup v-model="startShow" position="bottom" :style="{ height: '50%' }">
              <!-- <van-picker
                title="选择加盟标准"
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="startShow = false"
              /> -->

              <div class="criterion-wrap">
                <div class="opation">
                  <div class="cancel" @click="startShow = false">取消</div>
                  <div class="desc">选择加盟标准</div>
                  <div class="confirm" @click="onConfirm">确认</div>
                </div>
                <ul class="criterion-list">
                  <li class="criterion-item" 
                    :class="[item.checked ? 'on' : '']"
                    v-for="item in columns" 
                    :key="item.id"
                    @click="selectColumnsItem(item)"
                    >
                    <div class="criterion-item-wrap">
                      <div class="text-remarks-wrap">
                        <div class="text">{{item.describe}}</div>
                        <div class="remarks">{{item.remarks}}</div>
                      </div>

                      <div class="pay">
                        <img src="@images/renminbi.png">
                        <span>{{item.pay}}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </van-popup>
          </div>
        </div>
      </div>
      </div>
      <!-- <div class="uploader_form">
        <div class="tips"><span>*&nbsp;</span>请上传营业执照片</div>
          <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in businessLicense"
            :key="img"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="businessLicense.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="businessLicense.length < 1"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传照片</div>
            </div>
          </VueCoreImageUpload>
        </div>
        
      </div> -->
      <!-- <div class="uploader_form">
        <div class="tips"><span>*&nbsp;</span>请上传法人身份证照片（正反两张）</div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in IdCard"
            :key="img"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="IdCard.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="idCarduploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="IdCard.length < 2"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传照片</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div> -->
      <!-- <div class="uploader_form">
        <div class="tips">可上传公司环境、团队等照片</div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in otherImages"
            :key="img"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="otherImages.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="otherImagesuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="otherImages.length < 3"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传照片</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div> -->
      <div class="userform_item userform_item_textarea">
        <textarea placeholder="备注信息" cols="30" rows="6" v-model="formList.remark"></textarea>
      </div>
      <div class="agreement">
        <van-checkbox 
          v-model="checked" 
          shape="square" 
          checked-color="#9dccd0" 
          icon-size="18px"
          @click="is_agree = !is_agree"
          >已阅读并同意</van-checkbox>
        <div class="agreement-details" @click="showAgreement">用户协议</div>
        <van-popup 
          v-model="agreementShow"
          closeable
          >
          <div class="agreement-article">
            <div class="title">{{agreementContent.title}}</div>
            <div class="agreement-content" v-html="agreementContent.content"></div>
          </div>
          </van-popup>
      </div>
      <button class="userform_submit bg-color-red" @click="userformsubmit()">
        提交申请
      </button>
    </div>
    <div class="userform_description">
      <p>温馨提示：</p>
      {{ description }}
    </div>
    
  </div>
</template>
<script>

import {
  registerVerify,
  register,
  getCodeApi,
  userform,
  getAgreement
} from "@api/user";
import { VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getProvinceCity , getConditionLlistNew } from "@api/public";
import { conditionCreate } from "@api/order"
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
const _isWeixin = isWeixin();
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import Checkbox from 'vant/lib/checkbox';
import 'vant/lib/checkbox/style';
import CheckboxGroup from 'vant/lib/checkbox-group';
import 'vant/lib/checkbox-group/style';
export default {
  name:"CityAgentForm",
  components:{
    VueCoreImageUpload,
    CitySelect,
    [Picker.name]:Picker,
    [Popup.name]:Popup,
    [Checkbox.name]:Checkbox,
    [CheckboxGroup.name]:CheckboxGroup,
  },
  data: function() {
    return {
      formTitle:"城市盟主",
      from: _isWeixin ? "weixin" : "weixinh5",
      active: _isWeixin ? "weixin" : "yue",
      // 加盟方式
      startShow:false,
      columns: [],
      joinStandard:"",
      // 图片上传
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      businessLicense:[],
      IdCard:[],
      otherImages:[],
      //
      formList:{
        name:'',
        phone:'',
        agentcode: '',
        verifi:'',
        remark:'',
        agentlevelname: '',
        agentlevelamount: '',
      },
      formlabel: {
        warnstatus: 0,
        text: '姓名'
      },
      keyCode: '',
      type: '',
      codeVal: '',
      
      yzm: {text: '发送验证码',yzmstatus: false},
      yzmtime: 60,
      setyamtime: {},
      description: "请填写您的实名信息方便我们联系到您",
      agentlevelshow: false,
      checklevel: true,
      refund_reason_wap_img:[],
      // 城市选择弹窗
      show2: false,
      model2: "",
      district: [],
      address: {},
      ready: false,

      apply_id:"",
      apply_pay:"",
      agent_range:"",

      checked: false,
      is_agree:false,
      agreementShow:false,
      agreementContent:{},

      heightlight:''
    }
  },
  mounted: function() {
    this.agent_range = "city";
    if(this.agent_range == "city") this.formTitle = "城市盟主";
    if(this.agent_range == "province") this.formTitle = "省级盟主";
    this.getCode();
    this.getCityList();
    // this.getConditionLlist();
    this.getAgreement();
  },
  methods: {
    showAgreement(){
      this.agreementShow = true
    },
    getAgreement(){
      getAgreement().then(res =>{
        this.agreementContent = res.data[0]
      })
    },
    showPopup() {
      this.startShow = true;
    },
    checkCondition(){
      if(!this.address.city){
        return this.$dialog.message("请先选择城市");
      }
      this.showPopup();
    },
    imageuploaded(res) {
      if (res.status !== 200) return this.$dialog.error(res.msg || "上传图片失败");
      this.businessLicense.push(res.data.url);
    },
    idCarduploaded(res){
      if (res.status !== 200) return this.$dialog.error(res.msg || "上传图片失败");
      this.IdCard.push(res.data.url);
    },
    otherImagesuploaded(res){
      if (res.status !== 200) return this.$dialog.error(res.msg || "上传图片失败");
      this.otherImages.push(res.data.url);
    },
    openAgentLevel () {
      this.agentlevelshow = !this.agentlevelshow;
    },
    closeAgentLevel (index) {
      this.checklevel = false;
      this.formList.agentlevelname = this.agentarray[index].name;
      this.formList.agentlevelamount = this.agentarray[index].amount;
      this.agentlevelshow = false;
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      that.type = "register";
      await registerVerify({
        phone: that.formList.phone,
        type: that.type,
        key: that.keyCode,
        code: that.codeVal
      })
        .then(res => {
          if( that.yzm.text === '发送验证码' || res.msg === '发送成功') {
            that.yzm.yzmstatus = true;
            that.yzm.text = '已发送('+ that.yzmtime +')';
            clearInterval(that.setyzmtime);
            that.setyzmtime = setInterval(() => {
              that.yzmtime--;
              that.yzm.yzmstatus = true;
              that.yzm.text = '已发送('+ that.yzmtime +')';
              if( that.yzmtime <= 0){
                that.yzm.yzmstatus = false;
                that.yzm.text = '发送验证码';
                that.yzmtime = 60;
                clearInterval(that.setyzmtime);
              }
            }, 1000);
          }
          that.$dialog.success(res.msg);
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
            
    },
    async userformsubmit() {
      
      if(!this.formList.name){
        this.formlabel.warnstatus = 1;
        this.formlabel.text = '姓名';
      }else if(!this.formList.phone){
        this.formlabel.warnstatus = 2;
        this.formlabel.text = '电话';
      }else if(!(/^1[34578]\d{9}$/.test(this.formList.phone))){
        this.$dialog.message("请输入正确的手机号")
      }else if(!this.formList.verifi){
        this.formlabel.warnstatus = 3;
        this.formlabel.text = '验证码';
      }else{
        this.formlabel.warnstatus = 0;
        if(!this.joinStandard) return this.$dialog.message("请选择加盟标准");
        if(!this.model2) return this.$dialog.message("请选择城市");
        // if(this.businessLicense.length == 0) return this.$dialog.message("请上传营业执照");
        // if(this.IdCard.length < 2) return this.$dialog.message("请上传法人身份证");
        if(!this.is_agree) return this.$dialog.message("请先阅读并同意用户协议");
        
        // 信息均已，向服务器传递申请人信息
        console.log(
          this.formList.name,
          this.formList.phone,
          this.formList.verifi,
          this.joinStandard.id,
          this.model2,
          this.businessLicense,
          this.IdCard,
          this.otherImages.length > 0 ? this.otherImages : [],
          this.formList.remark != "" ? this.formList.remark : "",
          )
        userform ({
          name:this.formList.name,
          phone:this.formList.phone,
          verifi:this.formList.verifi,
          content:this.formList.remark || "",
          condition_id:this.joinStandard.id,
          business_license:this.businessLicense,
          id_card:this.IdCard,
          other_images:this.otherImages.length > 0 ? this.otherImages : [],
          agent_city:this.address.city,
          agent_province:this.address.province,
          agent_range:this.agent_range,
          is_agree:this.is_agree
        })
        .then(res => {
          let that = this
          if(res.data.status == 0){
            this.$dialog.success("提交成功");
            setTimeout(function(){
              that.$router.back()
            },1000)
          }else if(res.data.status == 1){
            this.$dialog.success("提交成功");
            let apply_id = res.data.id;
            this.conditionCreate(apply_id)
          }
        })
        .catch(res => {
          if (res.data.status === 402) {
            this.$dialog.error(res.msg);
          }else if (res.data.status === 400) {
            this.$dialog.error(res.msg);
          }
          this.$dialog.error(res.msg);
        });
      }
    },
    // 创建订单
    conditionCreate(id){
      let orderid = id
      let data = {
        id : orderid,
        from : this.from,
        payType: this.active,
      };
      conditionCreate(data).then(res=>{
        this.$dialog.loading.close();
        const data = res.data;
        let url = "/order/status_agent/" + data.result.orderId;
        
        if(data.status == 'WECHAT_PAY'){
          pay(data.result.jsConfig).finally(() => {
              this.$router.push({
                path: `/order/status_agent/${data.result.orderId}`
              });
            });
        }else{
          this.$dialog.error("支付失败");
        }
        return
        // switch (data.status) {
        //     case "ORDER_EXIST":
        //     case "EXTEND_ORDER":
        //     case "PAY_DEFICIENCY":
        //     case "PAY_ERROR":
        //       this.$dialog.toast({ mes: res.msg });
        //       this.$router.replace({
        //         path: url + "/0?msg=" + res.msg
        //       });
        //       break;
        //     case "SUCCESS":
        //       this.$dialog.success(res.msg);
        //       this.$router.replace({
        //         path: url + "/1"
        //       });
        //       break;
        //     case "WECHAT_H5_PAY":
        //       this.$router.replace({
        //         path: url + "/2"
        //       });
        //       setTimeout(() => {
        //         location.href = data.result.jsConfig.mweb_url;
        //       }, 100);
        //       break;
        //     case "WECHAT_PAY":
        //       pay(data.result.jsConfig).finally(() => {
        //         this.$router.replace({
        //           path: url + "/4"
        //         });
        //       });
        //   }
        console.log(res)
      })
    },
    // 验证码
    yzmClick: function () {
      if(this.yzm.yzmstatus) return;
      this.code();
    },
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " ";
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;
      // 获取条件
      this.getConditionLlistNew(this.address.city_id);
    },
    // 获取城市列表
    getCityList: function() {
      let that = this;
      getProvinceCity()
        .then(res => {
          that.district = res.data;
          that.ready = true;
        })
        .catch(err => {
          that.$dialog.error(err.msg);
        });
    },
    // 获取加盟标准
    getConditionLlistNew(city_id){
      getConditionLlistNew(city_id).then(res =>{
        this.columns = res.data;
      }).catch(res=>{
        this.$dialog.error(res.msg)
      })
    },
    selectColumnsItem(item){
      this.heightlight = item.id;
      this.columns.forEach(i => {
        if(i.hasOwnProperty('checked')){
          i.checked = false;
        }else{
          this.$set(i,'checked',false);
        }
      })
      item.checked = true;
      // if(!item.hasOwnProperty('checked')){
      //   console.log(123)
      // }
      // this.$set(item,'checked',true);
      // console.log(this.columns)
      // this.joinStandard = item;
    },
    // 加盟标准确认
    onConfirm(){
      let res = this.columns.filter(item => {
        return item.checked
      })
       if(res.length === 0 && res.length !== 1) return this.$dialog.message('请选择一项加盟标准');
       this.joinStandard = res[0];
      this.startShow = false;
      // this.joinStandard = value;
      // console.log("@@@@@@@@@@",this.joinStandard);
      

    }
  },
  watch:{
    startShow(newvalue,oldvalue){
      this.columns.forEach(item => {
        if(item.id === this.joinStandard.id){
          if(item.hasOwnProperty('checked')){
            item.checked = true;
          }else{
            this.$set(item,'checked',true);
          }
        }else{
          if(item.hasOwnProperty('checked')){
            item.checked = false;
          }else{
            this.$set(item,'checked',false);
          }
          
        }
      })

      // if(this.joinStandard === ''){
      //   this.columns.forEach(i => {
      //     if(i.hasOwnProperty('checked')){
      //       i.checked = false;
      //     }else{
      //       this.$set(i,'checked',false);
      //     }
      //   })
      // }
      // else{
      //   this.columns.forEach(i => {
      //     if(this.joinStandard.id === i.id){
      //       this.$set(i,'checked',true)
      //     }
      //   })
      // }
      
    }
  }
};
</script>
<style scoped>
.uploader_form{margin-bottom:.2rem}
.uploader_form .upload .pictrue{margin-right:.22rem;width:1.56rem;height:1.56rem;position:relative;font-size:0.24rem;color:#bbb;border:1px solid #bbb}
.uploader_form .upload .pictrue img{width:100%;height:100%}
.uploader_form .upload .pictrue .icon-guanbi1{position:absolute;font-size:0.45rem;top:-0.1rem;right:-0.1rem;width:0.45rem;height:0.45rem;line-height:0.45rem}
.userform_top{width:100%;height:150px;position:absolute;top:0;left:0;z-index:999;background:linear-gradient(0deg,#434343,#000000);background:-webkit-linear-gradient(0deg,#434343,#000000);background:-moz-linear-gradient(0deg,#434343,#000000);background:-ms-linear-gradient(0deg,#434343,#000000)}
.userform{font-size:15px;box-sizing:border-box;border-radius:0.8em;padding:1.6em;width:85%;margin:50px auto 0;background:#ffffff;box-shadow:2px 2px 16px 0 rgba(0,0,0,0.08);color:#000;position:relative;z-index:1000}
.userform .userform_title{text-align:center;font-size:20px;padding-bottom:1.2em}
.userform .userform_item{width:100%;margin:0 auto;margin-bottom:1.6em;display:flex;justify-content:space-between;align-items:center;position:relative}
.userform .userform_item_red:before{content:"*";display:block;padding:0 0.4em;color:rgb(223,53,53);position:absolute}
.userform .userform_item .yzm{width:7.6em;padding:0 0.6em;background:#80cdd4;color:#ffffff;margin-left:0.6em;line-height:2.4em;text-align:center}
.userform .userform_item_agent{border-bottom:1px solid #80cdd4;color:#80cdd4}
.userform  .userform_item_agent .agent_level_info{width:100%;display:flex;justify-content:space-between;line-height:2.4em;padding-left:1.2em}
.userform .userform_item_agent .agent_level_child{box-sizing:border-box;width:100%;position:absolute;top:2.4em;z-index:1000;color:#000;background:#ffffff;box-shadow:0 2px 12px 0 rgba(0,0,0,0.1);line-height:2em;padding:1em;border-radius:0 0 4px 4px;border-top:1px solid #80cdd4}
.userform .userform_item_agent .agent_level_name span{display:inline-block;color:#80cdd4;font-weight:600;margin-right:0.3em}
.userform .userform_item .yzm.actived{background:#f2f2f2;color:#999999}
.userform .userform_item .yzm_number{width:8em;text-align:center;letter-spacing:1px}
.userform .userform_item .agentcode{width:10.6em;text-align:center;color:#000;margin-right:0.4em}
.userform .userform_item input,.userform .userform_item textarea{width:100%;display:block;background:#f5f5f5;border-radius:4px;color:#000;line-height:1.6em;padding:0.6em 0.6em}
.userform .userform_item input{line-height:2.4em;padding:0 1em}
.userform .userform_item_textarea.userform_item{align-items:flex-start}
.userform .userform_item_bottom{display:flex}
.userform .userform_item .userform_agreement{display:flex}
.userform .userform_item .userform_agreement span{color:#80cdd4}
.userform_item_label{font-size:12px;color:rgb(255,70,70);position:absolute;left:0;bottom:-2em;z-index:1000;text-indent:1em;line-height:2em;text-align:left}
.userform_submit{margin:0 auto;display:block;width:80%;line-height:2.4em;border-radius:1.2em;background:linear-gradient(90deg,#80cdd4,#80cdd4);background:-webkit-linear-gradient(90deg,#80cdd4,#80cdd4);background:-moz-linear-gradient(90deg,#80cdd4,#80cdd4);background:-ms-linear-gradient(90deg,#80cdd4,#80cdd4);text-align:center;font-weight:600;color:#452f0d}
.userform_description{width:90%;margin:0 auto;font-size:14px;padding-top:2em;line-height:1.6em;color:#80cdd4}
.userform_description p{font-size:1.2em;display:inline-block;font-weight:600}
.uploader_form .tips{font-size:.3rem;color:#848484;margin-bottom:.2rem}
.uploader_form .tips span{color:rgb(223,53,53)}
.agreement{display:flex;margin-bottom:1.6em}
.agreement .agreement-details{color:#9dccd0}
.van-popup.van-popup--center{border-radius:10px}
.agreement-article{width:80vw;height:80vh;padding:.5rem .4rem .4rem;border-radius:10px}
.agreement-article .title{font-size:.48rem;font-weight:700;margin-bottom:.3rem}


.criterion-wrap .opation{display: flex;justify-content: space-between;padding: .2rem .3rem;border-bottom: 1px solid #f0f0f0;}
.criterion-wrap .opation .cancel,.criterion-wrap .opation .confirm{font-size: .32rem;color: #2c92d7;}
.criterion-wrap .opation .desc{font-size: .32rem;color: #000;font-weight: 600;}
.criterion-wrap .criterion-list{white-space: nowrap;overflow-x: scroll;margin:.54rem 0; scrollbar-width: none;-ms-overflow-style: none;}
.criterion-wrap .criterion-list::-webkit-scrollbar{display: none;}
.criterion-wrap .criterion-list .criterion-item:first-of-type{margin-left: .5rem;}
.criterion-wrap .criterion-list .criterion-item{display: inline-block;width: 4.5rem;height: 5.4rem;white-space: normal;padding: .32rem .28rem;border: 1px solid #e1e1e1;border-radius: 10px;vertical-align: bottom;margin-right: .4rem;}
.criterion-wrap .criterion-list .criterion-item.on{border-color: #cea85f;background: rgb(206, 168, 95,.12);}
.criterion-list .criterion-item .criterion-item-wrap{display: flex;flex-wrap: wrap;height: 100%;align-content: space-between;}
.criterion-list .criterion-item .text{font-size: .3rem;color: #333;font-weight: 700;text-align: justify;}
.criterion-list .criterion-item .remarks{font-size: .28rem;color: #a7a7a7;text-align: justify;margin-top: .16rem;}
.criterion-list .criterion-item .pay{width:100%;text-align: right;font-size: .48rem;color: #cea85f;font-weight: 500;line-height: 1;}
.criterion-list .criterion-item .pay img{width: .36rem;vertical-align: bottom;}
</style>

<style>
.agreement-content *{word-break:break-all}
</style>
